<template lang="pug">

  text-input(name="address", :label="label", meta)

</template>

<script>

import TextInput from './TextInput'

export default {
  name: 'user-input-address',

  components: {
    TextInput,
  },

  props: {
    label: {
      type: String,
      default: 'Address',
    },
  },
}

</script>
